// Redux
// import React from 'react';
import { Provider } from "react-redux";
import { usePageTracking } from "@/hooks/usePageTracking";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "@/app/store";
import AuthChecker from "@/components/AuthChecker";
// Navigation
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Icons
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import {
  faGithub,
  faLinkedin,
  faFacebook,
  faInstagram,
  faXTwitter,
  faTiktok,
  faYoutube,
  faTwitch,
  faSpotify,
  faWhatsapp,
  faCcVisa,
  faCcMastercard,
  faPaypal,
  faCcPaypal,
  faGooglePay,
  faApplePay,
} from "@fortawesome/free-brands-svg-icons";
import {
  faTwitter,
  faFontAwesome,
  faGooglePlay,
  faApple,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
library.add(
  fas,
  far,
  faTwitter,
  faFontAwesome,
  faGithub,
  faLinkedin,
  faGooglePlay,
  faApple,
  faGoogle,
  faFacebook,
  faInstagram,
  faXTwitter,
  faTiktok,
  faYoutube,
  faTwitch,
  faSpotify,
  faWhatsapp,
  faCcVisa,
  faCcMastercard,
  faPaypal,
  faCcPaypal,
  faGooglePay,
  faApplePay,
);

// Layout Components
import MainLayout from "@/layouts/MainLayout";
import CrearEmpresaLayout from "@/layouts/CrearEmpresaLayout";
import ActivarmeComoEmbajadorLayout from "@/layouts/ActivarmeComoEmbajadorLayout";
// Protected Routes
import ProtectedRoute from "@/components/ProtectedRoute";

// Pages
import Home from "@/pages/Home";
import ClubEmbajadores from "@/pages/ClubEmbajadores";
import ClubEmpresas from "@/pages/ClubEmpresas";
import ClubArtistas from "@/pages/ClubArtistas";
import NotFound from "@/pages/NotFound";
import ComoFunciona from "@/pages/ComoFunciona";
import PoliticaDePrivacidadYTerminosYCondiciones from "@/pages/PoliticaDePrivacidadYTerminosYCondiciones";
// Additional Pages
import CommingSoon from "@/pages/CommingSoon";
import ConfirmarUsuario from "@/pages/ConfirmarUsuario";
import ReenviarCodigoParaConfirmarUsuario from "@/pages/ReenviarCodigoParaConfirmarUsuario";
import EnviarCodigoParaOlvidoDePassword from "@/pages/EnviarCodigoParaOlvidoDePassword";
import ConfirmarCambioDePasswordPorOlvido from "@/pages/ConfirmarCambioDePasswordPorOlvido";

// Direct Access Pages
import Perfil from "@/pages/Perfil";
import UsuarioPerfil from "@/pages/UsuarioPerfil";
import TicketsUsuarioId from "@/pages/TicketsUsuarioId";
import InvitacionDetalle from "@/pages/InvitacionDetalle";

// Pages Generales
import EventoDetail from "@/pages/EventoDetail";

// Pages acción Crear y actualizar
import CrearPerfilEmpresa from "@/pages/CrearPerfilEmpresa";
import CrearEvento from "@/pages/CrearEvento";

// Pages "Ver Como"
import PerfilViewEmpresaOwnerEmpresa from "@/pages/PerfilViewEmpresaOwnerEmpresa";
import ViewEventoOwnerEmpresa from "@/pages/ViewEventoOwnerEmpresa";

// Providers
import { ModalsProvider } from "@/contexts/ModalsContext";
import { CartProvider } from "@/contexts/CartContext";

// Debug component -- only for development
// import DebugAuth from "@/components/DebugAuth";

function PageTracker() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<div>Cargando...</div>} persistor={persistor}>
        {/* <AuthChecker> */}
        <CartProvider>
          <ModalsProvider>
            <Router>
              <PageTracker />
              {/* Solo activar <DebugAuth /> en desarrollo */}
              {/* <DebugAuth /> */}
              <Routes>
                {/* Home */}
                <Route
                  path="/"
                  element={
                    <MainLayout>
                      <Home />
                    </MainLayout>
                  }
                />
                {/* Detalle de Evento para comprar tickets */}
                <Route
                  path="/evento/:id"
                  element={
                    <MainLayout>
                      <EventoDetail />
                    </MainLayout>
                  }
                />
                {/* Rutas relacionadas con el Perfil */}
                {/* Perfil Propio, como de otro Usuario y una Empresa */}
                <Route
                  path="/perfil/:id"
                  element={
                    <MainLayout>
                      <ProtectedRoute>
                        <Perfil />
                      </ProtectedRoute>
                    </MainLayout>
                  }
                />
                {/* Vista pública de perfil de usuario */}
                <Route
                  path="/usuario/:id"
                  element={
                    <MainLayout>
                      <UsuarioPerfil />
                    </MainLayout>
                  }
                />
                {/* Vista pública de perfil de usuario */}
                <Route
                  path="/usuario/:id"
                  element={
                    <MainLayout>
                      <UsuarioPerfil />
                    </MainLayout>
                  }
                />
                {/* Detalle de un Ticket que el Usuario ha comprado */}
                <Route
                  path="/perfil/:id/tickets/:idTicket"
                  element={
                    <MainLayout>
                      <ProtectedRoute>
                        <TicketsUsuarioId />
                      </ProtectedRoute>
                    </MainLayout>
                  }
                />
                {/* Detalle de una Invitacion del Usuario */}
                <Route
                  path="/perfil/:id/invitaciones/:uidInvitacion"
                  element={
                    <MainLayout>
                      <ProtectedRoute>
                        <InvitacionDetalle />
                      </ProtectedRoute>
                    </MainLayout>
                  }
                />
                {/* Crear Empresa */}
                <Route
                  path="/empresa/crear"
                  element={
                    <CrearEmpresaLayout>
                      <ProtectedRoute>
                        <CrearPerfilEmpresa />
                      </ProtectedRoute>
                    </CrearEmpresaLayout>
                  }
                />
                {/* Ver Detalle de Empresa */}
                <Route
                  path="/empresa/:id"
                  element={
                    <MainLayout>
                      <PerfilViewEmpresaOwnerEmpresa />
                    </MainLayout>
                  }
                />
                {/* Activar Empresa */}
                <Route
                  path="/empresa/:id/activar"
                  element={
                    <CrearEmpresaLayout>
                      <ProtectedRoute>
                        <PerfilViewEmpresaOwnerEmpresa />
                      </ProtectedRoute>
                    </CrearEmpresaLayout>
                  }
                />
                {/* Activar como Embajador */}
                <Route
                  path="/perfil/:id/activar-embajador"
                  element={
                    <ProtectedRoute>
                      <ActivarmeComoEmbajadorLayout>
                        <Perfil />
                      </ActivarmeComoEmbajadorLayout>
                    </ProtectedRoute>
                  }
                />

                {/* Crear Evento */}
                <Route
                  path="/empresa/:id/evento/:idEvento"
                  element={
                    <MainLayout>
                      <ProtectedRoute>
                        <CrearEvento />
                      </ProtectedRoute>
                    </MainLayout>
                  }
                />
                {/* Editar Evento */}
                {/* <Route
              path="/evento/editar/:id"
              element={
                <MainLayout>
                  <CrearEvento /> {/* TODO: Reusar el mismo componente de CrearEvento --
                </MainLayout>
              }
            /> */}

                {/* Ver Detalle de Evento de Empresa */}
                <Route
                  path="/empresa/:id/evento/:idEvento/dashboard"
                  element={
                    <MainLayout>
                      <ProtectedRoute>
                        <ViewEventoOwnerEmpresa />
                      </ProtectedRoute>
                    </MainLayout>
                  }
                />

                {/* Ver Evento en el que me aceptaron Como Embajador */}
                {/* <Route
              path="/perfil/ver/evento/:id"
              element={
                <MainLayout>
                  <ViewEventoComoEmbajador /> TODO: Crear este componente --
                </MainLayout>
              }
            /> */}

                {/* Proceso de Crear nuevo Usuario */}
                {/* Confirmar Usuario - Ingresar Código de Verificación */}
                <Route
                  path="/confirmar-usuario"
                  element={<ConfirmarUsuario />}
                />
                <Route
                  path="/reenviar-codigo-confirmar-usuario"
                  element={<ReenviarCodigoParaConfirmarUsuario />}
                />
                {/* Confirmar Cambio de Contraseña por Olvido */}
                <Route
                  path="/forgot-password"
                  element={<EnviarCodigoParaOlvidoDePassword />}
                />
                <Route
                  path="/confirm-forgot-password"
                  element={<ConfirmarCambioDePasswordPorOlvido />}
                />

                {/* Rutas de navegación generales */}
                {/* Politicas, Términos y Condiciones */}
                <Route
                  path="/politica-de-privacidad-y-terminos-y-condiciones"
                  element={
                    <MainLayout>
                      <PoliticaDePrivacidadYTerminosYCondiciones />
                    </MainLayout>
                  }
                />
                {/* Comming Soon */}
                <Route path="/comming-soon" element={<CommingSoon />} />
                {/* Club de Embajadores */}
                <Route
                  path="/club-de-embajadores"
                  element={
                    <MainLayout>
                      <ClubEmbajadores />
                    </MainLayout>
                  }
                />
                {/* Club de Empresas */}
                <Route
                  path="/club-de-empresas"
                  element={
                    <MainLayout>
                      <ClubEmpresas />
                    </MainLayout>
                  }
                />
                {/* Club de Artistas */}
                <Route
                  path="/club-de-artistas"
                  element={
                    <MainLayout>
                      <ClubArtistas />
                    </MainLayout>
                  }
                />
                {/* Cómo Funciona */}
                <Route path="/como-funciona" element={<ComoFunciona />} />

                {/* 404 Not Found - Debe ir al final de las rutas */}
                <Route
                  path="*"
                  element={
                    <MainLayout>
                      <NotFound />
                    </MainLayout>
                  }
                />
              </Routes>
            </Router>
          </ModalsProvider>
        </CartProvider>
        {/* </AuthChecker> */}
      </PersistGate>
    </Provider>
  );
}

export default App;
